import { CardMedia } from '@mui/material';

const LogoName = 'nippon-logo.svg';

const logoWidth = { xs: '220px', sm: '300px' };

export const Logo1 = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="Nippon India Alternate Investments Logo"
      sx={{ width: logoWidth, m: 3 }}
    />
  );
};

export const LogoEditApplication = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt=" Nippon India Alternate Investments Logo"
      sx={{ width: logoWidth, m: 3, my: 1 }}
    />
  );
};

export const LogoSideBar = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="Nippon India Alternate Investments Logo"
      sx={{ width: logoWidth }}
    />
  );
};
